'use client'

import React from 'react'
import Image from 'next/image'
import Link from 'next/link'

interface EmptyStateButton {
  label?: string
  href?: string
  onClick?: (e?: any) => void
  primary?: boolean
  icon?: React.ReactNode
  customElement?: React.ReactNode
}

interface ProfileEmptyStateProps {
  image: string
  title: string
  description: string
  buttons?: EmptyStateButton[]
  imageWrapperClassName?: string
  imageClassName?: string
}

const ProfileEmptyState: React.FC<ProfileEmptyStateProps> = ({
  image,
  title,
  description,
  buttons,
  imageWrapperClassName,
  imageClassName = 'object-contain',
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6 text-center">
      <div
        className={`mb-6 flex w-full max-w-[180px] sm:max-w-[220px] items-center justify-center ${
          imageWrapperClassName ?? ''
        }`}
      >
        <img
          src={image}
          alt={title}
          width={180}
          height={180}
          className={imageClassName}
        />
      </div>
      <div className="flex flex-col w-full items-center justify-center max-w-2xl">
        <h3 className="mb-2 text-lg sm:text-xl font-bold text-gray-900">{title}</h3>
        <p className="text-sm sm:text-base text-gray-600 mb-6 leading-relaxed">
          {description}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 items-center justify-center w-full">
          {buttons?.map((button, index) => (
            button.customElement ? (
              <div key={index}>{button.customElement}</div>
            ) : button.href ? (
              <Link
                key={index}
                href={button.href}
                className={`flex h-9 sm:h-10 px-6 items-center justify-center rounded-full transition-colors font-medium text-sm ${
                  button.primary
                    ? 'bg-[#85C349] text-white hover:bg-[#75b339]'
                    : 'border border-[#85C349] text-[#85C349] hover:bg-[#F3FAEB]'
                }`}
              >
                {button.icon && <span className="mr-2 flex items-center">{button.icon}</span>}
                {button.label}
              </Link>
            ) : (
              <button
                key={index}
                onClick={button.onClick}
                className={`flex h-9 sm:h-10 px-6 items-center justify-center rounded-full transition-colors font-medium text-sm ${
                  button.primary
                    ? 'bg-[#85C349] text-white hover:bg-[#75b339]'
                    : 'border border-[#85C349] text-[#85C349] hover:bg-[#F3FAEB]'
                }`}
              >
                {button.icon && <span className="mr-2 flex items-center">{button.icon}</span>}
                {button.label}
              </button>
            )
          ))}
        </div>
      </div>
    </div>
  )
}

export default ProfileEmptyState
